<template>
  <el-card class="box-card main-card">
    <el-tabs v-model="activeName">
      <el-tab-pane label="用户管理" name="user">

      </el-tab-pane>
      <el-tab-pane label="数据导出" name="export">
        <el-form :inline="true" :model="exportForm" class="demo-form-inline">
          <el-form-item label="请选择日期">
            <el-date-picker size="small"
                v-model="exportForm.dateValue"
                type="daterange"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                :picker-options="expireTimeOPtion"
                value-format="yyyy-MM-dd"
                :clearable="true">
            </el-date-picker>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" size="small" class="el-button el-button--primary " @click="exportFn">导出</el-button>
          </el-form-item>
        </el-form>
      </el-tab-pane>
    </el-tabs>
    <div v-show="activeName === 'user'">
      <el-row type="flex" justify="space-between">
      <el-col :span="22">
        <el-form class="" ref="form" :model="searchForm" :inline="true">
          <el-form-item label="用户名称：" label-width="85px">
            <el-input v-model="searchForm.userName" clearable placeholder="请输入用户名称" size="small"></el-input>
          </el-form-item>
          <el-form-item label="手机号：" label-width="85px">
            <el-input v-model="searchForm.mobile" clearable placeholder="请输入手机号" size="small"></el-input>
          </el-form-item>
          <el-form-item label="" label-width="85px">
            <el-button class="pxy-primary" size="small" @click="searchFn">查询</el-button>
          </el-form-item>
        </el-form>
      </el-col>
    </el-row>
      <el-table
        :data="tableData"
        style="width: 100%">
        <template v-for="item in columns">
          <el-table-column :prop="item.key" :label="item.label" :key="item.id"></el-table-column>
        </template>
        <el-table-column label="注册时间">
          <template slot-scope="scope">
            {{scope.row.createDate | formatDateTime}}
          </template>
        </el-table-column>
        <el-table-column label="操作" fixed="right" min-width="100">
          <template slot-scope="scope">
            <!-- 0:有效 1：禁用 -->
            <el-button size="small" class="pxy-primary" @click="rowChangeFn(scope.row)" style="marginRight:15px;">
              {{scope.row.status === 0 ? '锁定': '激活'}}
            </el-button>
            <el-dropdown size="small" type="click" @command="handleFn">
              <el-button v-popover:popover size="small" class="pxy-primary">
                更多
              </el-button>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item :command="{command: 1,row: scope.row}">充值</el-dropdown-item>
                <el-dropdown-item :command="{command: 2,row: scope.row}">调配</el-dropdown-item>
                <el-dropdown-item :command="{command: 3,row: scope.row}">查看账单</el-dropdown-item>
                <el-dropdown-item :command="{command: 4,row: scope.row}">查看订单</el-dropdown-item>
                <el-dropdown-item :command="{command: 5,row: scope.row}">查看收支明细</el-dropdown-item>
<!--                <el-dropdown-item :command="{command: 6,row: scope.row}">查看优惠券</el-dropdown-item>-->
                <el-dropdown-item :command="{command: 7,row: scope.row}">查看授权码</el-dropdown-item>
                <el-dropdown-item :command="{command: 8,row: scope.row}">查看托管应用</el-dropdown-item>
           <!--     <el-dropdown-item :command="{command: 9,row: scope.row}">设置定向分区</el-dropdown-item>-->
                <el-dropdown-item :command="{command: 10,row: scope.row}">查看转发代理服务</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>

          </template>
        </el-table-column>
      </el-table>
      <PageComponent ref="pageInfo"></PageComponent>
    </div>
    <!-- 充值弹窗 -->
    <el-dialog
      title="充值"
      :visible.sync="chargeDialogVisible"
      width="576px">
      <el-form ref="chargeForm" :model="chargeForm" label-width="100px" style="width: 70%;margin: 0 auto;"
               :rules="rules">
        <el-form-item label="用户名称：">
          <el-input size="small" style="width: 260px;" readonly v-model="handleRow.accountId"></el-input>
          <!-- <span>{{}}</span> -->
        </el-form-item>
        <el-form-item label="永久余额：">
          <el-input size="small" style="width: 260px;" readonly v-model="chargeForm.balance"></el-input>
          <!-- <span>{{}}</span> -->
        </el-form-item>
        <el-form-item label="时效余额：">
          <el-input size="small" style="width: 260px;" readonly v-model="chargeForm.tempBalance"></el-input>
          <!-- <span>{{}}</span> -->
        </el-form-item>
        <el-form-item label="充值金额：" prop="charge">
          <el-input v-model="chargeForm.charge" placeholder="请输入金额" size="small" style="width: 260px;"></el-input>
        </el-form-item>
        <el-form-item label="类型：" prop="payType">
          <el-radio-group v-model="chargeForm.payType">
            <el-radio label="31">赠送金额</el-radio>
            <el-radio label="41">储值金额</el-radio>
          </el-radio-group>
        </el-form-item>

        <el-form-item label="到期日：" v-if="chargeForm.payType == '31'" prop="expireTime">
          <el-date-picker

            v-model="chargeForm.expireTime"
            align="right"
            type="date"
            placeholder="选择日期"
            :picker-options="expireTimePickerOptions">
          </el-date-picker>
          <el-tooltip effect="light" placement="top-start">
            <div slot="content" class="tip-info">充值金有效期。可以不选择，表示永久有效</div>
            <i class="el-icon-question tip-icon"></i>
          </el-tooltip>
        </el-form-item>
        <el-form-item label="备注：" prop="note">
          <el-input placeholder="请输入备注" size="small" style="width: 260px;" v-model="chargeForm.note"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button class="pxy-primary" @click="saveChargeFn">保 存</el-button>
      </span>
    </el-dialog>
    <!-- 调配弹窗 -->
    <el-dialog title="调配" :visible.sync="quotaDialogVisible" width="576px">
      <el-table :data="quotaTableData">
        <el-table-column prop="prodName" label="产品名称"></el-table-column>
        <el-table-column prop="quota" label="配额">
          <template slot-scope="scope">
            <div v-show="!scope.row.isEdit">
              <span>{{scope.row.quota}}</span>
              <i class="el-icon-edit" style="fontSize: 18px;color: #FF6B00;marginLeft: 10px;cursor: pointer;"
                 @click="isEditFn(scope.row,scope.$index)"></i>
            </div>
            <el-input :ref="'input'+scope.$index" v-show="scope.row.isEdit" @blur="isEditBlurFn(scope.row,scope.$index)"
                      :autofocus="true" v-model="scope.row.quota"></el-input>
          </template>
        </el-table-column>
      </el-table>
      <el-table :data="prodItemUserCustomData">
        <el-table-column prop="prodItemName" label="产品名称"></el-table-column>
        <el-table-column prop="price" label="单价">
          <template slot-scope="scope">
            <div v-show="!scope.row.isEdit">
              <span>{{scope.row.price}}</span>
              <i class="el-icon-edit" style="fontSize: 18px;color: #FF6B00;marginLeft: 10px;cursor: pointer;"
                 @click="isEditProdItemUserCustomDataFn(scope.row,scope.$index)"></i>
            </div>
            <el-input :ref="'prodItemUserCustomDataInput'+scope.$index" v-show="scope.row.isEdit"
                      @blur="editProdItemUserCustom(scope.row,scope.$index)" :autofocus="true"
                      v-model="scope.row.price"></el-input>
          </template>
        </el-table-column>
      </el-table>
    </el-dialog>
  </el-card>
</template>
<script>
  import PageComponent from '@/components/pageInfo/PageComponent'
  import {Message} from 'element-ui'

  const columns = [{
    key: 'accountId',
    label: '登录ID'
  },{
    key: 'userTypeSelf',
    label: '用户类型'
  },
  // {
  //   key: 'email',
  //   label: '邮箱地址'
  // },
  {
    key: 'mobile',
    label: '电话'
  },
  {
    key: 'company',
    label: '公司名称'
  }, 
  {
    key: 'busiScope',
    label: '业务领域'
  },
  {
    key: 'jobTitle',
    label: '岗位'
  },
  {
    key: 'provinceSelf',
    label: '地址'
  },
  {
    key: 'statusSelf',
    label: '状态'
  },
  ]
  const validDecimals = (rule, value, callback) => {
    if (value === '' || value === 0) {
      callback(new Error('请输入充值金额！'))
    } else if (!(/(^[1-9]\d*$)/.test(Number(value)))) {
      callback(new Error('请输入正整数！'))
    } else {
      callback()
    }
  }
  export default {
    components: {
      PageComponent
    },
    data() {
      return {
        activeName: 'user',
        columns: columns,
        tableData: [],
        searchForm: {
          userName: '',
          mobile: ''
        },
        role: {
          1: '个人用户',
          2: '企业用户',
          30: '系统用户'
        },
        userStatus: {
          0: '有效', // 正常
          1: '禁用', // 锁定
        },
        chargeDialogVisible: false, // 充值弹窗
        chargeForm: {
          balance: '', // 永久余额
          tempBalance: '', //时效金额
          charge: 0,
          note: '',
          payType: '31',
          expireTime: null
        },
        quotaDialogVisible: false, // 调配弹窗
        quotaTableData: [],
        userConfig:{},
        prodItemUserCustomData: [],
        rules: {
          charge: [{required: true, message: '请输入充值金额', trigger: 'blur'},
            {validator: validDecimals, trigger: 'blur'}],
          type: [{required: true, message: '请选择充值类型', trigger: 'blur'},
            {validator: validDecimals, trigger: 'blur'}],
          note: [{required: true, message: '请输入备注', trigger: 'blur'}
          ],
          expireTime: [{required: true, message: '请输入时效金有效期', trigger: 'blur'}]
        },
        handleRow: {}, // 当前操作行的数据
        preQuota: null, // 存储当前刚更改的配额
        expireTimePickerOptions: {
          disabledDate(time) {
            return time.getTime() < Date.now();
          },
          shortcuts: [{
            text: '一周',
            onClick(picker) {
              const date = new Date();
              date.setTime(date.getTime() + 3600 * 1000 * 24 * 7);
              picker.$emit('pick', date);
            }
          }, {
            text: '一个月',
            onClick(picker) {
              const date = new Date();
              date.setTime(date.getTime() + 3600 * 1000 * 24 *30);
              picker.$emit('pick', date);
            }
          }, {
            text: '一年',
            onClick(picker) {
              const date = new Date();
              date.setTime(date.getTime() + 3600 * 1000 * 24 * 365);
              picker.$emit('pick', date);
            }
          }]
        },
        exportForm: {
          dateValue: ''
        },
        // dayMin: '',
        expireTimeOPtion: {
          onPick: (time) => {
          this.$nextTick(() => {
            if(time.minDate) this.dayMin = new Date(time.minDate).getTime();

            if(time.maxDate){
              this.dayMin = ''
            }
          })
        },
          disabledDate: (time)=>{
            return time.getTime() > Date.now()
            // let times = 14 * 24 * 60 * 60 * 1000 ;// 最多只能选择15天
            // if (this.dayMin !== '') {
            //   // 大于选中时间后15天 || 小于选中时间后15天 || 大于今天 的所有日期都禁用
            //   return time.getTime() > (this.dayMin + times) || time.getTime() < (this.dayMin - times) || time.getTime() > Date.now()
            // }else{
            //   // 什么都没选，只禁用大于今天的所有日期
            //   return time.getTime() > Date.now()
            // }
          }
        },
      }
    },
    mounted() {
      this.getUserList();
      this.$refs.pageInfo.initPagenator(this.getUserList, 10);
      this.getNowTime();
    },
    methods: {
      // 数据导出
      exportFn() {
        let params = {}
        if(this.exportForm.dateValue) {
          params.dateStart = this.exportForm.dateValue[0];
          params.dateEnd = this.exportForm.dateValue[1];
        }
        this.getRequestFile('/uacUser/download', params).then(resp => {
          if (resp.status == 200) {
            const filename = decodeURI(resp.headers['content-disposition'].split(';')[1].split('=')[1]);
            this.fileDownload(resp.data, filename);
          } else {
            console.error("error")
          }
        })
      },
      fileDownload(data, fileName) {
        const blob = new Blob([data], {
          type: 'application/octet-stream'
        })
        const filename = fileName || 'filename.xlsx'
        if (typeof window.navigator.msSaveBlob !== 'undefined') {
          window.navigator.msSaveBlob(blob, filename)
        } else {
          let blobURL = window.URL.createObjectURL(blob)
          let tempLink = document.createElement('a')
          tempLink.style.display = 'none'
          tempLink.href = blobURL
          tempLink.setAttribute('download', filename)
          if (typeof tempLink.download === 'undefined') {
            tempLink.setAttribute('target', '_blank')
          }
          document.body.appendChild(tempLink)
          tempLink.click()
          document.body.removeChild(tempLink)
          window.URL.revokeObjectURL(blobURL)
        }
      },
      getNowTime() {
        var now = new Date();
        var year = now.getFullYear(); // 得到年份
        var month = now.getMonth(); // 得到月份
        var date = now.getDate(); // 得到日期
        month = month + 1;
        month = month.toString().padStart(2, '0');
        date = date.toString().padStart(2, '0');
        var defaultDate = `${year}-${month}-${date}`;
        this.$set(this.exportForm, 'dateValue', [defaultDate,defaultDate]);
      },
      //获取用户管理列表
      getUserList() {
        var params = {};
        params.page = this.$refs.pageInfo.currentPage;
        params.pageSize = 10;
        if (this.searchForm.userName !== '') {
          params.accountId = this.searchForm.userName;
        }
        if (this.searchForm.mobile !== '') {
          params.mobile = this.searchForm.mobile;
        }
        this.getRequest('/uacUser/list', params).then(resp => {
          if (resp.status == 200) {
            if (resp.data.code == 1000) {
              this.tableData = resp.data.result.records.map(item => {
                const provinceName = item.city?item.city:'';
                const cityName = item.province?item.province:'';
                return Object.assign(item, {
                  userTypeSelf: this.role[item.role],
                  statusSelf: this.userStatus[item.status],
                  provinceSelf: provinceName+'/'+cityName
                })
              })
              this.$refs.pageInfo.outputPagenator(resp.data.result.total);
            } else {
              Message.error(resp.data.message);
            }
          } else {
            console.error("error")
          }
        })
      },
      // 查询
      searchFn() {
        if (this.$route.query.page === '1') {
          this.getUserList();
        } else {
          this.$router.push({query: {page: 1}});
        }
      },
      // 锁定/激活
      rowChangeFn(row) {
        let params = {
          userId: row.userId,
          status: row.status === 1 ? 0 : 1,
        }
        this.postRequestJson("/uacUser/update", params).then(resp => {
          if (resp && resp.status == 200 && resp.data.code === 1000) {
            this.$message.success({message: row.status === 0 ? '锁定成功!' : '激活成功!'});
            this.getUserList();
          }
        });
      },
      // 更多操作
      handleFn(val) {
        this.handleRow = val.row; // 当前操作行的数据
        switch (val.command) {
          case 1:
            this.getBalance(val.row.userId); //查询余额
            this.chargeDialogVisible = true;
            break;
          case 2:
            this.getUacUserConfig(val.row.userId); // 查询配额
            this.getProdItem(val.row.userId);//查询单价
            this.quotaDialogVisible = true;
            break;
          case 3:
            this.$router.push({ // 查看账单
              path: '/account/bill',
              query: {
                userId: val.row.userId,
                userName: val.row.accountId
              }
            })
            break;
          case 4:
            this.$router.push({ // 查看订单
              path: '/account/myOrder',
              query: {
                userId: val.row.userId,
                userName: val.row.accountId
              }
            })
            break;
          case 5:
            this.$router.push({ // 查看收支明细
              path: '/account/accountLog',
              query: {
                userId: val.row.userId,
                userName: val.row.accountId
              }
            })
            break;
          case 6:
            this.$router.push({ // 查看优惠券
              path: '/account/coupon',
              query: {
                userId: val.row.userId,
                userName: val.row.accountId
              }
            })
            break;
          case 7:
            this.$router.push({ // 查看授权码
              path: '/userManage/sn',
              query: {
                userId: val.row.userId,
                userName: val.row.accountId
              }
            })
            break;
          case 8:
            this.$router.push({ // 查看托管应用
              path: '/userManage/appli',
              query: {
                userId: val.row.userId,
                userName: val.row.accountId
              }
            })
            break;
          case 9:
            this.$router.push({ // 设置定向分区
              path: '/setting/index',
              query: {
                from: "settingSpecifiedRegion",
                userId: val.row.userId,
                accountId: val.row.accountId
              }
            })
            break;
          case 10:
            this.$router.push({ // 跳转到转发代理一览
              path: '/agent/index',
              query: {
                from: "agentIndex",
                userId: val.row.userId,
                accountId: val.row.accountId
              }
            })
            break;
          default:
            break;

        }
      },
      // 查询余额
      getBalance(userId) {
        var params = {
          userId
        };
        this.getRequest('/uacUserConfig/getInfo', params).then(resp => {
          if (resp.status == 200) {
            if (resp.data.code == 1000) {
              if (resp.data.result ) {
                const balance = resp.data.result.permanentBalance;
                const tempBalance = resp.data.result.timeLimitedBalance;
                this.chargeForm.balance = balance || (balance === 0 ? 0 : '');
                this.chargeForm.tempBalance = tempBalance || (tempBalance === 0 ? 0 : '');
              }
            } else {
              Message.error(resp.data.message);
            }
          } else {
            console.error("error")
          }
        })
      },
      getUacUserConfig: function (userId) {
        this.quotaTableData = [];
        this.getRequest('/uacUserConfig/getInfo', {"userId": userId}).then(resp => {
          if (resp.status == 200) {
            if (resp.data.code == 1000) {
              this.userConfig = resp.data.result;
              this.appliConfigs = this.userConfig.appliQuota.split(",");
              this.quotaTableData.push({prodName: '授权码', quota: this.userConfig.snQuota})
              this.quotaTableData.push({prodName: '托管应用（数量）', quota: this.appliConfigs[1]})
              this.quotaTableData.push({prodName: '托管应用（存储GB）', quota: this.appliConfigs[0]})
              this.quotaTableData.push({prodName: '托管应用（并发）', quota: this.appliConfigs[2]})
            } else {
              Message.error(resp.data.message);
            }
          }
        })
      },
      // 调配弹窗 -> 编辑配额
      isEditFn(row, index) {
        this.preQuota = row.quota;
        this.$set(this.quotaTableData[index], 'isEdit', !row.isEdit);
        if (row.isEdit) {
          this.$nextTick(() => {
            this.$refs['input' + index].$refs.input.focus();
          })
        }
      },
      // 调配弹窗 -> 编辑配额结束
      isEditBlurFn(row, index) {
        if (row.quota === '') {
          Message.error('配额不能为空！')
        }  else {
          let params = {
            userId: this.handleRow.userId
          }
          let i = -1;
          if(row.prodName == '托管应用（数量）'){
            i = 1;
          }else if(row.prodName == '托管应用（存储GB）'){
            i = 0;
          }else  if(row.prodName == '托管应用（并发）'){
            i = 2;
          }
          if(i != -1){
            let appliQuota = this.replaceAppliQuotaStr(i, row.quota);
            params.appliQuota = appliQuota;
          }else {
            params.snQuota = row.quota;
          }
          this.postRequestJson("/uacUserConfig/updateQuota", params).then(resp => {
            if (resp && resp.status == 200 && resp.data.code === 1000) {
              this.$message.success('修改配额成功！');
              this.$set(this.quotaTableData[index], 'isEdit', !row.isEdit);
            } else {
              this.$message.error(data.message);
            }
          });
        }
      },

      //调整托管应用某个配额时，替换配额变量
      replaceAppliQuotaStr(index, newValue) {
        const parts = this.userConfig.appliQuota.split(','); // 以逗号分割字符串
        if (parts.length > 1) {
          parts[index] = newValue; // 替换第二位的值
        }
        return parts.join(','); // 用逗号重新连接字符串
      },

      // 查询单价
      getProdItem(userId){
        this.getRequest('/pocPriceItem/list', {"type": 3,"userId":userId}).then(resp => {
          if (resp.status == 200) {
            if (resp.data.code == 1000) {
              var prodItemResultList =  resp.data.result;
              this.getProdItemUserCustom(userId,prodItemResultList);
            }
          }
        })
      },
      // 查询单价
      getProdItemUserCustom(userId,prodItemResultList) {
        var params = {
          userId,
        };
        var prodItemUserCustomData = prodItemResultList.filter(function (x) {
          return   x.id == "876869352356537689" || x.id == "876869352356547789" || x.id == "876869353356547889"
        }).map(item => {
            return {"userId":userId,"prodId":item.prodId,"prodItemId":item.id,"prodItemName":item.itemName,"price":item.price}
        })
        this.getRequest('/pocPriceItemCustom/getList', params).then(resp => {
          if (resp.status == 200) {
            if (resp.data.code == 1000) {
              let data = resp.data.result;
              console.log(data);
              var prodItemUserCustomKeyValue = {};
              for(var i = 0; i < data.length; i++){
                prodItemUserCustomKeyValue[data[i].prodItemId] = data[i].price
              }
              console.log(prodItemUserCustomKeyValue)
              this.prodItemUserCustomData = prodItemUserCustomData.map(item => {
                if(prodItemUserCustomKeyValue.hasOwnProperty(item.prodItemId)){
                  item.price = prodItemUserCustomKeyValue[item.prodItemId]
                }
                return item;
              })

              console.log( this.prodItemUserCustomData )
            } else {
              Message.error(resp.data.message);
            }
          } else {
            console.error("error")
          }
        })
      },
      // 调整单价弹窗
      isEditProdItemUserCustomDataFn(row, index) {
        this.$set(this.prodItemUserCustomData[index], 'isEdit', !row.isEdit);
        if (row.isEdit) {
          this.$nextTick(() => {
            this.$refs['prodItemUserCustomDataInput' + index].$refs.input.focus();
          })
        }
      },
      // 调整价格弹窗
      editProdItemUserCustom(row, index) {
        if (row.price === '') {
          Message.error('价格不能为空！')
        } else {
          let params = {
            userId: this.handleRow.userId,
            prodId: row.prodId,
            prodItemId: row.prodItemId,
            price: row.price
          }
          this.postRequestJson("/pocPriceItemCustom/add", params).then(resp => {
            if (resp && resp.status == 200 && resp.data.code === 1000) {
              this.$message.success('修改配额成功！');
              this.$set(this.prodItemUserCustomData[index], 'isEdit', !row.isEdit);
            } else {
              this.$message.error(resp.data.message);
            }
          });
        }
      },
      saveChargeFn() {
        this.$refs.chargeForm.validate((valid) => {
          if (valid) {
            let params = {
              userId: this.handleRow.userId,
              amount: parseInt(this.chargeForm.charge),
              payType: this.chargeForm.payType,
              note: this.chargeForm.note
            }
            if(this.chargeForm.expireTime != null){
              params.expireTime = new Date(this.chargeForm.expireTime).getTime();
            }
            this.postRequestJson("/ofcRechargeLog/add", params).then(resp => {
              if (resp && resp.status == 200 ) {
                if(resp.data.code === 1000){
                  this.$message.success({message: '充值成功'});
                  this.getUserList();
                  this.$refs.chargeForm.resetFields();
                  this.chargeDialogVisible = false;
                  this.chargeForm = {
                    balance: '', // 余额
                    charge: 0,
                    payType: "31",
                    note: ''
                  }
                }else {
                  Message.error(resp.data.message);
                }

              }

            });
          }
        })
      },
    }
  }
</script>
<style lang='less' scoped>

</style>
